import { Box, TextField, Typography } from "@mui/material"
import { useState, useEffect } from "react"
import { StyledMetricTab } from "./Atom"
import BucketEditMenu from "../../../Menu/BucketEditMenu"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import PermsWrapper from "../../../Auth/PermsWrapper"
import { permissions } from "../../../../../config/constants"

type Props = {}

const StyledTab = (props: any) => {
  const [anchorEl, setAnchorEl] = useState<any>(null)

  const {
    tab,
    index,
    handleChange,
    selectedTab,
    handleBucketUpdateOpen,
    handleBucketDeleteOpen,
  } = props

  return (
    <StyledMetricTab
      disableRipple={true}
      key={tab?.metric_bucket_id}
      label={
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              whiteSpace: "nowrap !important",
            }}
          >
            <Typography>{tab?.metric_bucket}</Typography>
            <PermsWrapper perm={permissions?.BLUEPRINT_BUCKET_MAINTENANCE}>
              <BucketEditMenu
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                selectedTab={selectedTab}
                index={index}
                value={tab?.metric_bucket}
                bucketId={tab?.metric_bucket_id}
                handleBucketUpdateOpen={handleBucketUpdateOpen}
                handleBucketDeleteOpen={handleBucketDeleteOpen}
              />
            </PermsWrapper>
          </Box>
        </Box>
      }
      onClick={(event: any) => handleChange(event, index)}
      sx={{
        backgroundColor: selectedTab === index ? "#ffffff" : "#1c56ce",
        color: selectedTab === index ? "black" : "white",
        marginLeft: index === 0 ? "8px" : "0",
        fontSize: "16px",
        fontWeight: selectedTab === index ? "600" : "400",
        textTransform: "capitalize",
      }}
    />
  )
}

export default StyledTab
